<template>
  <div class="container">
    <div id="order-holder">

      <div v-if="!isLoading" class="webshop-cart-pages">
        <StepIndicator/>
        <CartTable v-if="currentStep!='Cart' && currentStep!='Summary'"/>
        <router-view/>
      </div>

      <div class="order-holder-loading" v-bind:class="[ isLoading ? '' : 'hidden' ]">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      </div>
    </div>
  </div>
</template>

<style lang="less">

</style>

<script>
import StepIndicator from '@/components/StepIndicator.vue'
import CartTable from '@/components/CartTable.vue'
import { mapGetters } from "vuex";

export default {
  components: {
    StepIndicator,
    CartTable
  },
  computed: {
    ...mapGetters({
      isLoading: 'getIsLoading',
      currentStep: "getCurrentStep",
    }),
  },
  mounted() {
    this.$store.dispatch('setDefaultData');
  },
}
</script>